/* ds-compare.js - Debug Store, 2026-10-30, updated 2026-10-31.
   Product Comparison tab: customers add products (same comparison group) or remove them.
   Adding stops once the columns no longer fit: a label column plus 150 px per product (110 + 130 px
   below 750 px wide), never fewer than 2 products and never more than 5. Default columns that do not
   fit scroll sideways rather than being hidden. A product is added with the Add button, not on select change.
   Added products come from /products/<handle>?view=ds-compare (templates/product.ds-compare.liquid).
   If a fetch fails the column is not added and a message says so. */
(function () {
  if (window.dsCompareLoaded) return;
  window.dsCompareLoaded = true;

  var HARD_MAX = 5, HARD_MIN = 2;

  function money(pence, cur) {
    var whole = pence % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(pence / 100);
    } catch (e) { return ''; }
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function init(root) {
    var table = root.querySelector('table');
    var headRow = table.tHead.rows[0];
    var scroll = root.querySelector('[data-ds-cmp-scroll]');
    var select = root.querySelector('[data-ds-cmp-add]');
    var diff = root.querySelector('[data-ds-cmp-diff]');
    var msg = root.querySelector('[data-ds-cmp-msg]');
    var addBtn = root.querySelector('[data-ds-cmp-addbtn]');
    var pending = {};
    var group = root.getAttribute('data-group') || '';
    var S = window.Shopify || {};
    var base = (S.routes && S.routes.root) || '/';

    function handles() {
      return [].map.call(headRow.querySelectorAll('th[data-h]'), function (th) { return th.getAttribute('data-h'); });
    }
    function maxCols() {
      var w = scroll.clientWidth || root.clientWidth;
      var narrow = window.innerWidth < 750;
      var label = narrow ? 110 : 180, col = narrow ? 130 : 150;
      return Math.max(HARD_MIN, Math.min(HARD_MAX, Math.floor((w - label) / col)));
    }
    var note = '';
    function setMsg(t) { if (msg.textContent !== t) msg.textContent = t; }
    function syncOptions() {
      var shown = handles(), left = 0;
      [].forEach.call(select.options, function (o) {
        if (!o.value) return;
        o.disabled = shown.indexOf(o.value) > -1;
        if (!o.disabled) left++;
      });
      return left;
    }
    function refresh() {
      if (!scroll.clientWidth) return; // tab closed: keep the current state until it is shown
      var left = syncOptions();
      var full = handles().length >= maxCols();
      select.disabled = full || !left;
      if (addBtn) addBtn.disabled = select.disabled;
      if (note) setMsg(note);
      else if (select.options.length < 2) setMsg('');
      else if (!left) setMsg('All similar products are already shown.');
      else if (full) setMsg('No more products fit at this screen width. Remove one to add another.');
      else setMsg('');
      note = '';
      applyDiff();
    }
    function applyDiff() {
      [].forEach.call(table.tBodies[0].rows, function (tr) {
        if (!diff.checked || tr.getAttribute('data-key') === '_price') { tr.hidden = false; return; }
        var vals = [].map.call(tr.querySelectorAll('td'), function (td) { return td.textContent.trim().toLowerCase(); });
        tr.hidden = vals.length > 1 && vals.every(function (v) { return v === vals[0]; });
      });
    }
    function remove(h) {
      var th = headRow.querySelector('th[data-h="' + h + '"] .ds-cmp__name');
      var name = th ? th.textContent : 'Product';
      [].forEach.call(table.querySelectorAll('[data-h="' + h + '"]'), function (c) { c.parentNode.removeChild(c); });
      note = name + ' removed from the comparison.';
      refresh();
      if (!select.disabled) select.focus(); else scroll.focus();
    }
    function addColumn(d) {
      var th = el('th', 'ds-cmp__head');
      th.scope = 'col';
      th.setAttribute('data-h', d.handle);
      if (d.img) {
        var img = el('img', 'ds-cmp__img');
        img.src = d.img; img.alt = ''; img.width = 80; img.height = 80; img.loading = 'lazy';
        th.appendChild(img);
      }
      var a = el('a', 'ds-cmp__name', d.title);
      a.href = d.url;
      th.appendChild(a);
      if (d.sku) th.appendChild(el('span', 'ds-cmp__sku', d.sku));
      if (d.stock) th.appendChild(el('span', 'ds-cmp__stock' + (d.stock === 'In stock' ? ' is-in' : ''), d.stock));
      var btn = el('button', 'ds-cmp__remove', 'Remove');
      btn.type = 'button';
      btn.setAttribute('data-ds-cmp-remove', d.handle);
      btn.setAttribute('aria-label', 'Remove ' + d.title + ' from the comparison');
      th.appendChild(btn);
      headRow.appendChild(th);

      [].forEach.call(table.tBodies[0].rows, function (tr) {
        var key = tr.getAttribute('data-key');
        var td = el('td');
        td.setAttribute('data-h', d.handle);
        if (key === '_price') {
          if (d.p > 0) {
            var span = el('span', null, (d.varies ? 'From ' : '') + money(d.p, d.c));
            span.setAttribute('data-ds-price', d.handle);
            if (d.varies) span.setAttribute('data-ds-prefix', 'From ');
            span.setAttribute('data-ds-live', 'b');
            td.appendChild(span);
          } else td.textContent = 'Price on request';
        } else {
          var v = d.rows && Object.prototype.hasOwnProperty.call(d.rows, key) ? d.rows[key] : '';
          td.textContent = v === '' || v == null ? 'Not listed' : v;
        }
        tr.appendChild(td);
      });
    }

    function addSelected() {
      var h = select.value;
      if (!h || pending[h] || handles().indexOf(h) > -1) return;
      if (handles().length >= maxCols()) { refresh(); return; }
      pending[h] = true;
      select.value = '';
      setMsg('Loading');
      fetch(base + 'products/' + encodeURIComponent(h) + '?view=ds-compare', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) {
          if (!d || !d.handle || (group && d.group !== group)) throw new Error('group');
          if (handles().indexOf(d.handle) > -1) return;
          addColumn(d);
          note = d.title + ' added to the comparison.';
          refresh();
        })
        .catch(function () { setMsg('That product could not be added. Please try again.'); })
        .then(function () { delete pending[h]; });
    }
    if (addBtn) addBtn.addEventListener('click', addSelected);
    else select.addEventListener('change', addSelected);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ds-cmp-remove]');
      if (b) remove(b.getAttribute('data-ds-cmp-remove'));
    });
    diff.addEventListener('change', applyDiff);
    if ('ResizeObserver' in window) new ResizeObserver(refresh).observe(root);
    else window.addEventListener('resize', refresh);
    refresh();
  }

  function start() { [].forEach.call(document.querySelectorAll('[data-ds-cmp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
